import { Theme, makeStyles } from '@material-ui/core';

import { CarRegistrationNumberEditButtonProps } from './CarRegistrationNumberEditButton.interfaces';

export const useStyles = ({
  responsive,
}: CarRegistrationNumberEditButtonProps) =>
  makeStyles(({ custom, breakpoints }: Theme) => ({
    button: {
      position: 'relative',
      paddingLeft: 40,
      ...(responsive && {
        [breakpoints.down('xs')]: {
          padding: 8,
          minWidth: 'initial',
        },
      }),
    },
    euroband: {
      position: 'absolute',
      left: 0,
      top: 0,
      zIndex: 2,
      height: '100%',
      width: 30,
      background: '#2358D0 url("./images/misc/euroband.svg") no-repeat center',
      backgroundSize: 'contain',
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6,
      ...(responsive && {
        [breakpoints.down('xs')]: {
          display: 'none',
        },
      }),
    },
    labelEmpty: {
      color: custom.grey[19],
    },
    prefix: {
      ...(responsive && {
        [breakpoints.up('sm')]: {
          display: 'none',
        },
      }),
    },
  }));
